import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  GuardResult,
  MaybeAsync,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { UserService } from '../shared/services/user.service';
import { ProfileService } from '../modules/profile/profile-edit/profile.service';
import { SupabaseUserToolsService } from '../shared/services/supabase-user-tools.service';
import { SupabaseService } from '../shared/services/supabase.service';

@Injectable({
  providedIn: 'root',
})
export class ProfileInfoPendingGuard implements CanActivate {
  constructor(
    private userService: UserService,
    private profileService: ProfileService,
    private router: Router,
    private supabaseUserToolService: SupabaseUserToolsService,
    private supabaseService: SupabaseService
  ) {}
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const user = await this.userService.getUserPromise();
    if (user.data.user?.id) {
      const hasFullfiledInfo =
        await this.profileService.checkIfUserHasFullfiledPersonalInfo(
          user.data.user?.id
        );
      const approval = await this.supabaseUserToolService.getApprovalState();
      // Only a CONFIRMED "not approved" may lead to the waiting page. An
      // indeterminate answer (no club id yet, RPC error) must never trap an
      // approved member there; the calendar's own guards decide downstream.
      if (hasFullfiledInfo && approval !== 'not_approved') {
        await this.router.navigate(['/calendar']);
        return false;
      }
      if (!hasFullfiledInfo) return true;

      // approval === 'not_approved': a member who really waits for the admin.
      const isRejected = await this.supabaseUserToolService.isUserRejected();

      if (isRejected) {
        await this.router.navigate(['/']);
        return false;
      }

      const adminGotNotifiedForVerification = localStorage.getItem(
        'adminGotNotifiedForVerification'
      );
      if (
        !adminGotNotifiedForVerification ||
        adminGotNotifiedForVerification.length < 1 ||
        adminGotNotifiedForVerification !== 'true'
      ) {
        this.supabaseService.supabase.functions
          .invoke('notifyAdminThatSomeoneNeedsToBeVerified', {
            body: {
              full_name: '',
              club_id: localStorage.getItem('club_id'),
              clubURL: window.location.origin,
              user_id: user.data.user?.id,
            },
          })
          .then((res) => {
            console.log(res);
            if (!res.error)
              localStorage.setItem('adminGotNotifiedForVerification', 'true');
          });
      }
      await this.router.navigate(['/pendingVerification']);
      return false;
    }
    this.router.navigate(['/']);
    return true;
  }
}
